'use client';

import styles from './AgentCard.module.scss';
import IllustrationBg from './assets/illustration-bg-logo.svg';
import DynamicIllustration from './DynamicIllustration';
import { KibChewyLogo } from '@chewy/kib-logos-react';

export interface AgentCardData {
    /** The agent's name */
    agentName: string;
    /** The team name (e.g., "Customer care team member") */
    teamName?: string;
    /** The agent's user ID */
    agentUserId?: string;
}

export interface AgentCardProps {
    /** The widget data containing agent info */
    data?: AgentCardData;
}

export default function AgentCard({ data }: AgentCardProps) {
    const {
        agentName = '',
        teamName = 'Customer care team member',
        agentUserId = '',
    } = data ?? {};

    return (
        <div className={styles.card}>
            <div className={styles.leftContent}>
                <span className={styles.agentName}>{agentName}</span>
                <span className={styles.teamName}>{teamName}</span>
            </div>
            <div className={styles.rightContent} aria-hidden="true">
                <IllustrationBg className={styles.illustrationBg} />
                <div className={styles.contents}>
                  <KibChewyLogo className={styles.chewyBgLogo} />
                  <DynamicIllustration className={styles.illustration} agentUserId={agentUserId} />
                </div>
            </div>
        </div>
    );
}
